import { map } from 'rxjs/operators';
import { filter, Observable } from 'rxjs';
import {  Maybe, Resource, ResourcesGQL } from '@iss/libs/graphql';
import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';

@Pipe({ name: 'resource', pure: false, standalone: true })
export class ResourcePipe implements PipeTransform, OnDestroy {
  private readonly asyncPipe = new AsyncPipe(inject(ChangeDetectorRef));
  private readonly resourcesGQL = inject(ResourcesGQL);

  private code?: Maybe<Resource['code']>;
  private name$!: Observable<string | null>;

  public transform(code: Maybe<Resource['code']>): string | null {
    if (!code) return null;
    if (code !== this.code) {
      this.code = code;
      this.name$ = this.fetch(this.code);
    }

    return this.asyncPipe.transform(this.name$);
  }

  public ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  protected fetch(code: Maybe<Resource['code']>): Observable<string | null> {
    return this.resourcesGQL.fetch({ input: { offset: 0, limit: 999, includeInactive: true } }).pipe(
      map(({ data }) => data),
      filter(Boolean),
      map(({ resources }) => resources.resources.find(resource => resource.code === code)),
      map(resource => resource?.presentedName || null),
    );
  }
}
